import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-burger-menu',
  templateUrl: './burger-menu.component.html',
  styleUrls: ['./burger-menu.component.scss'],
})
export class BurgerMenuComponent {
  @Input() isActive = false;
  @Output() menuCanceled = new EventEmitter<boolean>();

  onCancel() {
    this.menuCanceled.emit(false);
  }
}
